'use client';

import { AppBar, Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import MainNavContainer from './Main-Navigation/MainNavContainer';
import TopNavContainer from './Top-Navigation/TopNavContainer';
import { useStyles } from './style';
import SkipToMainContent from './SkipToMainContent';

/**
 * @name HeaderContainer
 * @description Header Container
 * @param {object} root0  - destructured object
 * @param {object} root0.cmsHeaderData  - Header data from strapi
 * @returns {JSX.Element} JSX.Element
 */
const HeaderContainer = ({ cmsHeaderData }) => {
  const theme = useTheme();
  const style = useStyles(theme);

  return (
    <AppBar position='static' sx={style.appBar}>
      <Grid container>
        <Grid item xs={12} sx={{ backgroundColor: theme.palette.default.backgroundColor3 }}>
          <SkipToMainContent />
        </Grid>
        <Grid item xs={12} sx={{ backgroundColor: theme.palette.default.backgroundColor3 }}>
          <TopNavContainer navCmsHeaderData={cmsHeaderData} />
        </Grid>
        <Grid item xs={12}>
          <MainNavContainer
            nav={cmsHeaderData?.PrimaryNav}
            leftNav={cmsHeaderData?.SecondaryNavLeft}
            rightNav={cmsHeaderData?.SecondaryNavRight}
            icons={cmsHeaderData?.Icons}
            cartTitle={cmsHeaderData?.cartTitle}
          />
        </Grid>
      </Grid>
    </AppBar>
  );
};

HeaderContainer.displayName = 'HeaderContainer';
export default HeaderContainer;
